import { Component, Inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ExercicioService } from '../../../../services/exercicio.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-exercicio-imagens-modal',
  templateUrl: './exercicio-imagens-modal.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule],
})
export class ExercicioImagensModalComponent implements OnInit {

  @Input() exercicioId!: number;

  imagens: any[] = [];
  file!: File;

  constructor(
    private service: ExercicioService,
    public activeModal: NgbActiveModal,
    @Inject('BASE_URL') private baseUrl: string,
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load() {
    this.service.getImagens(this.exercicioId)
      .subscribe(res => this.imagens = res);
  }

  onFileChange(event: any) {
    this.file = event.target.files[0];
  }

  upload() {
    if (!this.file) return;

    this.service.uploadImagem(this.exercicioId, this.file)
      .subscribe(() => {
        this.file = null!;
        this.load();
      });
  }

  delete(id: number) {
    this.service.deleteImagem(id)
      .subscribe(() => this.load());
  }

  getImagemUrl(fileServerName: string): string {
    if (!fileServerName) {
      return '';
    }

    if (/^https?:\/\//i.test(fileServerName)) {
      return fileServerName;
    }

    const normalizedBaseUrl = this.baseUrl.endsWith('/') ? this.baseUrl : `${this.baseUrl}/`;
    return `${normalizedBaseUrl}uploads/exercicios/${fileServerName}`;
  }
}